// extracted by mini-css-extract-plugin
module.exports = {"code":"htmlAttr_code__U_mp0"};